<script>
import options from "./ProductTile.options";
export default options;
</script>

<template>
    <article class="nti-product-tile">
      <a :href="cardData.url">
            <section class="nti-product-tile__image-wrapper">
                <div class="nti-product-tile__image-container" :style="cardData.imageUrl ? { backgroundImage: `url(${cardData.imageUrl})` } : null"></div>
                <div class="nti-product-tile__image-wrapper__label-container" :class="evalCardProductType">
                    <div v-if="isCourse && logoPath" class="nti-product-tile__image-container__logo">
                        <img :src="logoPath" alt="Course logo">
                    </div>
                    <span class="nti-product-tile__image-wrapper__label-container__label" :class="{ 'nti-product-tile__image-wrapper__label-container--Course-with-image' : logoPath && isCourse}">{{ productTypeDisplayName }}</span>
                </div>
            </section>
            <section class="nti-product-tile__info-wrapper">
                <h2 class="nti-product-tile__info-container__title">{{ cardData.displayName }}</h2>                   
                <div class="nti-product-tile__info-container__price__wrapper">
                    <span class="nti-product-tile__info-label">{{ verifyLabel("fromLabel") }}</span>
                    <p class="nti-product-tile__info-container__price" :class="{ 'nti-product-tile__info-container__price--old' : discountedProduct }">{{ formattedPrice }}</p>
                    <p  v-if="discountedProduct" class="nti-product-tile__info-container__price nti-product-tile__info-container__price--discount" >{{ formattedDiscountedPrice }}</p>
                    <span class="nti-product-tile__info-label nti-product-tile__info-label--bottom">{{ verifyLabel("exVat") }}</span>
                </div>
            </section>
            <section class="nti-product-tile__button-container">
                <button class="nti-button nti-button--no-border">{{ `${ productTypeSelectLabel }` }}</button>
            </section>
      </a>
    </article>
</template>